
import { mapGetters } from "vuex";
export default {
  beforeMount() {
    this.isKotMarketingEnabled = this.getBoolean(
      this.$ls.get("kot-marketing", false)
    );
    this.selectedKotMarketing = this.$ls.get(
      "selected-kot-marketing",
      this.getLocationChannels[0]?.name
    );
    this.kotMessage = this.$ls.get(
      "kot-marketing-message",
      this.getDefaultMessage
    );
    this.kotMarketingChange();
    this.handleSelectedKotMarketingChange();
    this.handleChangeKotMessage(true);
  },
  data() {
    return {
      valid: false,
      isKotMarketingEnabled: false,
      selectedKotMarketing: "",
      kotMessage: "",
      nameRule: [(v) => !!v || "Kot message is required"]
    };
  },
  computed: {
    ...mapGetters("restaurant", ["getLocationChannels"]),

    hasMessageNotChanged() {
      return this.$ls.get("kot-marketing-message") === this.kotMessage;
    },
    getDefaultMessage() {
      if (this.selectedKotMarketing === "whatsapp") {
        return "Scan the QR Code to order from us on WhatsApp, and Get your food delivered at dine-in prices";
      } else {
        return `Scan the QR Code & order from us on ${
          this.getChannelConstObj(this.selectedKotMarketing)?.label || ""
        }`;
      }
    }
  },
  methods: {
    kotMarketingChange() {
      this.$ls.set(
        "kot-marketing",
        this.isKotMarketingEnabled ? this.isKotMarketingEnabled : false
      );
    },
    handleSelectedKotMarketingChange() {
      this.$ls.set(
        "selected-kot-marketing",
        this.selectedKotMarketing
          ? this.selectedKotMarketing
          : this.getLocationChannels[0]?.name || ""
      );
    },
    handleChangeKotMessage(isInit = false) {
      this.$ls.set(
        "kot-marketing-message",
        this.kotMessage || this.getDefaultMessage
      );
      if (!isInit) {
        this.$nuxt.$emit("show-toast", {
          text: "KOT message updated successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });

        //for disabling the save button
        this.kotMessage = "";
        this.$nextTick(() => {
          this.kotMessage = this.$ls.get(
            "kot-marketing-message",
            this.getDefaultMessage
          );
        });
      }
    }
  }
};
